exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".additionalActivityContainer .slideDrawer{background:#fff;top:0;right:0;z-index:200;transform:translateX(100%);opacity:.01}.additionalActivityContainer .slideDrawer,.additionalActivityContainer .slideDrawer.open{transition:transform .5s ease-in,opacity .3s ease .3s;-moz-transition:transform .5s ease-in,opacity .3s ease .3s;-webkit-transition:transform .5s ease-in,opacity .3s ease .3s}.additionalActivityContainer .slideDrawer.open{opacity:1;transform:translateX(0)}.additionalActivityContainer .slideDrawer .optionalHeader{text-align-last:center;font-style:italic;display:block;margin-bottom:15px;font-weight:700}.additionalActivityContainer .drawerTrigger{position:absolute;bottom:0;right:0;cursor:pointer}.additionalActivityContainer .drawerTrigger:hover{font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/utility/sliding_drawer.scss
// module id = 1486
// module chunks = 0